"use client";

import Picture1 from "../images/must-experience/vietnam-image-1.jpg";
import Picture2 from "../images/must-experience/vietnam-image-2.jpg";
import Picture3 from "../images/must-experience/vietnam-img-14.jpg";
import Picture4 from "../images/must-experience/vietnam-img-15.jpg";
import Picture5 from "../images/must-experience/vietnam-img-16.jpg";
import Picture6 from "../images/must-experience/vietnam-img-17.jpg";
import Picture7 from "../images/must-experience/vietnam-img-18.jpg";
import Picture8 from "../images/must-experience/vietnam-img-19.jpg";
import Picture9 from "../images/must-experience/vietnam-img-20.jpg";
import Picture10 from "../images/must-experience/vietnam-img-21.jpg";
import Picture11 from "../images/must-experience/vietnam-img-22.jpg";
import Picture12 from "../images/must-experience/vietnam-image-3.jpg";


import Car from "@/public/svg/destinations/hand-picked/car.svg";
import Building from "@/public/svg/destinations/hand-picked/building.svg";
import Activity from "@/public/svg/destinations/hand-picked/activity.svg";

import TicketCard from "@/components/ticket-card/ticket-card";
import Title from "@/components/title/Title";

import "@/styles/common/swiper.scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss";

import "@/sections/common/horizontal-card/horizontal-card.scss";

const Honeymoon = [
    {
        name: "3N Ho Chi Minh | Mekong Delta",
        picture: Picture2,
        location: "Vietnam",
        place: "2 places",
        price: "₹20,799",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "3 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Phu Quoc Island",
        picture: Picture1,
        location: "Vietnam",
        place: "1 place",
        price: "₹25,499",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "3 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Recently Added",
                color: "#FFE5B4",
            },
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Hanoi | Ninh Binh | Halong Bay",
        picture: Picture3,
        location: "Vietnam",
        place: "3 places",
        price: "₹19,799",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "3 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Da Nang | Hoi An | Ba Na Hills",
        picture: Picture4,
        location: "Vietnam",
        place: "3 places",
        price: "₹22,399",
        type: "4 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "3 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "4 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Hanoi | Ninh Binh | 1N Halong Bay",
        picture: Picture5,
        location: "Vietnam",
        place: "3 places",
        price: "₹26,999",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "4 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "2N Hanoi | Halong Bay | 2N Saigon",
        picture: Picture6,
        location: "Vietnam",
        place: "3 places",
        price: "₹27,599",
        type: "5 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "4 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Recently Added",
                color: "#FFE5B4",
            },
            {
                title: "5 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "2N Hanoi | 1N Halong Bay | 2N Saigon",
        picture: Picture7,
        location: "Vietnam",
        place: "3 places",
        price: "₹32,199",
        type: "6 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "5 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Hanoi | Halong Bay | 2N Saigon",
        picture: Picture8,
        location: "Vietnam",
        place: "3 places",
        price: "₹31,899",
        type: "6 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "5 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "6 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Hanoi | Ninh Binh | 1N Halong Bay | 2N Saigon",
        picture: Picture9,
        location: "Vietnam",
        place: "4 places",
        price: "₹35,499",
        type: "7 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "6 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "7 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "2N Hanoi | 1N Halong Bay | 2N Danang | 2N Saigon",
        picture: Picture10,
        location: "Vietnam",
        place: "4 places",
        price: "₹44,399",
        type: "8 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "7 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "8 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "2N Hanoi | 1N Halong Bay | 2N Da Nang | 3N Saigon",
        picture: Picture11,
        location: "Vietnam",
        place: "4 places",
        price: "₹49,899",
        type: "9 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "8 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "9 days",
                color: "#d0cece",
            },
        ],
    },
    {
        name: "3N Hanoi | Ninh Binh | 1N Halong Bay | 2N Da Nang | 3N Saigon",
        picture: Picture12,
        location: "Vietnam",
        place: "5 places",
        price: "₹53,999",
        type: "10 days",
        list: [
            {
                icon: Building,
                title: "3 Star Hotels",
            },
            {
                icon: Activity,
                title: "9 Activities",
            },
            {
                icon: Car,
                title: "Transfers",
            },
        ],
        trends: [
            {
                title: "Most Booked",
                color: "#FFE5B4",
            },
            {
                title: "10 days",
                color: "#d0cece",
            },
        ],
    },
];

const HorizontalCard = () => {
    return (
        <section className="horizontal-card-section py-10 md:py-20">
            <div className="horizontal-card-container container px-4 flex flex-col mx-auto gap-6 sm:gap-14">
                <Title title="Vietnam Honeymoon Packages" />
                <div className="horizontal-card-wrapper flex flex-col gap-14">
                    {Honeymoon.map((h, index) => {
                        return <TicketCard key={index} {...h} />;
                    })}
                </div>
            </div>
        </section>
    );
};

export default HorizontalCard;
